<template #content>

    <!-- Boleto -->
    <div class="w-full">
        <div class="field mt-4 flex gap-2">
            <div class="w-12">
                <InputGroup>
                    <FloatLabel>
                        <InputText id="codigo_de_barras" v-model="data.codigo_de_barras" class="w-full" disabled />
                        <label for="codigo_de_barras">Código de Barras</label>
                    </FloatLabel>
                    <Button icon="pi pi-copy" severity="primary"
                        @click="copiarCodigo(data.codigo_de_barras)"
                        :disabled="!data.boleto_id" />
                </InputGroup>
            </div>
        </div>

        <div class="field mt-4 flex gap-2">
            <div class="w-12">
                <InputGroup>
                    <FloatLabel>
                        <InputText id="boleto" v-model="data.boleto" class="w-full" disabled />
                        <label for="boleto">Boleto</label>
                    </FloatLabel>
                    <Button icon="pi pi-download" severity="primary"
                        @click="download({ id: data.boleto_id, nome: data.boleto })"
                        :disabled="!data.boleto_id" />
                    <Button icon="pi pi-eye" severity="secondary"
                        @click="visualizar({ id: data.boleto_id, nome: data.boleto })"
                        :disabled="!data.boleto_id"></Button>
                    <Button icon="pi pi-trash" severity="danger" @click="remove(data.boleto_id, 'boleto')"
                        :disabled="!data.boleto_id"></Button>
                </InputGroup>
                <div class="text-xs text-right">
                    <template v-if="data.boleto_usuario">
                        {{ data.boleto_usuario }} ({{ dateFormat(data.boleto_date) }})
                    </template>
                </div>
            </div>
        </div>

        <!-- Upload de Arquivo -->
        <Fieldset legend="Upload de Arquivo">
            <!-- Toolbar com Botão -->
            <BlockUI :blocked="isLoadingBoleto" class="relative w-full px">
                <Toolbar>
                    <template #end>
                        <div class="flex gap-1">
                            <Button
                                label="Selecionar Arquivo"
                                icon="pi pi-folder-open"
                                severity="primary"
                                @click="openFileDialogBoleto"
                            />
                            <Button
                                label="Enviar"
                                icon="pi pi-upload"
                                severity="success"
                                :loading="isLoadingBoleto"
                                @click="handleUploadBoleto"
                            />
                            <Button
                                label="Limpar"
                                icon="pi pi-trash"
                                severity="danger"
                                @click="clearFileDialogBoleto"
                            />
                        </div>
                    </template>
                </Toolbar>

                <div class="field mt-4">
                    <FilePond
                        ref="pondBoleto"
                        name="arquivo"
                        labelIdle='Arraste o arquivo ou <span class="filepond--label-action">clique aqui</span>'
                        acceptedFileTypes="application/pdf"
                        :files="filesBoleto"
                        @updatefiles="onFileUpdateBoleto"
                        :instantUpload="false"
                    />
                </div>

                <div v-if="isLoadingBoleto" class="absolute" style="top: calc(50% - 20px); left: calc(50% - 20px);">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <!-- <i class="pi pi-spinner pi-spin text-4xl text-blue-100"></i> -->
                </div>
            </BlockUI>
        </Fieldset>

        <!-- <div class="field mt-4 flex gap-2">
            <div class="w-full">
                <FileUpload ref="upload1" name="arquivo" :url="uploadUrl('boleto')" chooseIcon="pi pi-file-plus"
                    chooseLabel="Selecionar" uploadLabel="Upload" @before-send="beforeUpload" accept=".pdf"
                    @upload="onUploaded" @error="onUploadError" :maxFileSize="50000000" :data="uploadData">
                    <template #empty>
                        <div class="text-center">
                            <div class="text-gray-600">
                                Arraste o arquivo aqui para fazer o upload.<br>
                                <i class="pi pi-cloud-upload text-6xl"></i>
                            </div>
                        </div>
                    </template>
                </FileUpload>
            </div>
        </div> -->
    </div>

    <!-- Comprovante -->
    <div class="w-full">
        <div class="field mt-4 flex gap-2">
            <div class="w-12">
                <InputGroup>
                    <FloatLabel>
                        <InputText id="comprovante" v-model="data.comprovante" class="w-full" disabled />
                        <label for="comprovante">Comprovante</label>
                    </FloatLabel>
                    <Button icon="pi pi-download" severity="primary"
                        @click="download({ id: data.comprovante_id, nome: LogForm.comprovante })"
                        :disabled="!data.comprovante_id" />
                    <Button icon="pi pi-eye" severity="secondary"
                        @click="visualizar({ id: data.comprovante_id, nome: data.comprovante })"
                        :disabled="!data.comprovante_id"></Button>
                    <Button icon="pi pi-trash" severity="danger" @click="remove(data.comprovante_id, 'comprovante')"
                        :disabled="!data.comprovante_id"></Button>
                </InputGroup>
                <div class="text-xs text-right">
                    <template v-if="data.comprovante_usuario">
                        {{ data.comprovante_usuario }} ({{ dateFormat(data.comprovante_date) }})
                    </template>
                </div>
            </div>
        </div>

        <!-- Upload de Arquivo -->
        <Fieldset legend="Upload de Arquivo">
            <!-- Toolbar com Botão -->
            <BlockUI :blocked="isLoadingComprovante" class="relative w-full px">
                <Toolbar>
                    <template #end>
                        <div class="flex gap-1">
                            <Button
                                label="Selecionar Arquivo"
                                icon="pi pi-folder-open"
                                severity="primary"
                                @click="openFileDialogComprovante"
                            />
                            <Button
                                label="Enviar"
                                icon="pi pi-upload"
                                severity="success"
                                :loading="isLoadingComprovante"
                                @click="handleUploadComprovante"
                            />
                            <Button
                                label="Limpar"
                                icon="pi pi-trash"
                                severity="danger"
                                @click="clearFileDialogComprovante"
                            />
                        </div>
                    </template>
                </Toolbar>

                <div class="field mt-4">
                    <FilePond
                        ref="pondComprovante"
                        name="arquivo"
                        labelIdle='Arraste o arquivo ou <span class="filepond--label-action">clique aqui</span>'
                        acceptedFileTypes="application/pdf"
                        :files="filesComprovante"
                        @updatefiles="onFileUpdateComprovante"
                        :instantUpload="false"
                    />
                </div>

                <div v-if="isLoadingComprovante" class="absolute" style="top: calc(50% - 20px); left: calc(50% - 20px);">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <!-- <i class="pi pi-spinner pi-spin text-4xl text-blue-100"></i> -->
                </div>
            </BlockUI>
        </Fieldset>

        <!-- <div class="field mt-4 flex gap-2">
            <div class="w-full">
                <FileUpload ref="upload2" name="arquivo" :url="uploadUrl('comprovante')" chooseIcon="pi pi-file-plus"
                    chooseLabel="Selecionar" uploadLabel="Upload" @before-send="beforeUpload" @upload="onUploaded($event, 'comprovante')"
                    @error="onUploadError" :maxFileSize="50000000">
                    <template #empty>
                        <div class="text-center">
                            <div class="text-gray-600">
                                Arraste o arquivo aqui para fazer o upload.<br>
                                <i class="pi pi-cloud-upload text-6xl"></i>
                            </div>
                        </div>
                    </template>
                </FileUpload>
            </div>
        </div> -->
    </div>
</template>
<script>
import vueFilePond from 'vue-filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import Fieldset from 'primevue/fieldset';
import Toolbar from 'primevue/toolbar';
import BlockUI from 'primevue/blockui';
import ProgressSpinner from 'primevue/progressspinner';

const FilePond = vueFilePond(FilePondPluginFileValidateType)

import Dialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import InputNumber from 'primevue/inputnumber';
import InputMask from 'primevue/inputmask';
import Checkbox from 'primevue/checkbox';
import AutoComplete from 'primevue/autocomplete';
import Button from 'primevue/button';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import DatePicker from 'primevue/datepicker';
import Textarea from 'primevue/textarea';
import FileUpload from 'primevue/fileupload';
import ScrollPanel from 'primevue/scrollpanel'


import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import Arquivo from '@/service/arquivo.js';

import Token from '@/utils/Token';
import File from '@/utils/File';

import LogForm from '@/components/LogForm.vue';

import Moment from 'moment';

export default {
    components: {
        Dialog,
        FloatLabel,
        Button,
        InputText,
        InputMask,
        Select,
        AutoComplete,
        Checkbox,
        InputNumber,
        InputGroup,
        InputGroupAddon,
        DatePicker,
        Textarea,
        FileUpload,
        ScrollPanel,
        Fieldset,
        Toolbar,
        BlockUI,
        ProgressSpinner,
        FilePond,

        Tabs,
        TabList,
        Tab,
        TabPanels,
        TabPanel,

        LogForm,
    },
    props: {
        data: {},
    },
    emits: ['save', 'remove', 'close'],
    data() {
        return {
            contrato: {},
            form: {},
            errors: {},

            filesBoleto: [],
            isLoadingBoleto: false,

            filesComprovante: [],
            isLoadingComprovante: false,

            continua: 0,
        }
    },
    mounted() {
        this.form = {...this.data};
    },
    methods: {
        // Boleto
        onFileUpdateBoleto(files) {
            this.filesBoleto = files.map(file => file.file)
        },
        openFileDialogBoleto() {
            this.$refs.pondBoleto.browse()
        },
        clearFileDialogBoleto() {
            this.filesBoleto = []
        },
        async handleUploadBoleto() {
            if (!this.form.contrato_id) {
                this.errors.contrato_id = "Campo obrigatório"
                return
            }

            if (this.filesBoleto.length === 0) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Nenhum arquivo selecionado',
                    life: 5000
                })
                return
            }

            this.isLoadingBoleto = true

            const formData = new FormData()
            formData.append('continua', this.continua);
            this.filesBoleto.forEach(file => {
                formData.append('arquivo', file)
            })

            try {
                // const response = await Arquivo.contaCarne(this.form.contrato_id, formData)
                const response = await Arquivo.contaBoleto(this.data.id, formData)

                this.filesBoleto = []
                this.continua = 0

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: `Boleto incluído com sucesso.`,
                    life: 3000
                })

                this.$emit('save', {data: response.data, route: 'boleto'});
            } catch (error) {
                if (error.response?.data?.erros) {
                    this.errors = error.response.data.erros
                } else if (error.response?.data?.msg) {

                    if (error.response.data.msg === 'Código de barras já foi cadastrado') {
                        this.$confirm.require({
                            message: 'Código de barras já existe. Deseja continuar mesmo assim?',
                            header: 'Confirmação',
                            icon: 'pi pi-exclamation-triangle',
                            rejectClass: 'bg-red-500 text-white',
                            accept: () => {
                                this.continua = 1;
                                this.handleUploadBoleto();
                            },
                            reject: () => {
                                this.$toast.add({
                                    severity: 'info',
                                    summary: 'Cancelado',
                                    detail: 'Upload cancelado',
                                    life: 3000
                                });
                            }
                        });

                        return;
                    }
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: error.response.data.msg,
                        life: 10000
                    })
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Erro ao realizar upload',
                        life: 5000
                    })
                }
            } finally {
                this.isLoadingBoleto = false
            }
        },

        // Comprovante
        onFileUpdateComprovante(files) {
            this.filesComprovante = files.map(file => file.file)
        },
        openFileDialogComprovante() {
            this.$refs.pondComprovante.browse()
        },
        clearFileDialogComprovante() {
            this.filesComprovante = []
        },
        async handleUploadComprovante() {
            if (!this.form.contrato_id) {
                this.errors.contrato_id = "Campo obrigatório"
                return
            }

            if (this.filesComprovante.length === 0) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Nenhum arquivo selecionado',
                    life: 5000
                })
                return
            }

            this.isLoadingComprovante = true

            const formData = new FormData()
            this.filesComprovante.forEach(file => {
                formData.append('arquivo', file)
            })

            try {
                // const response = await Arquivo.contaCarne(this.form.contrato_id, formData)
                const response = await Arquivo.contaComprovante(this.data.id, formData)

                this.filesComprovante = []

                this.$toast.add({
                    severity: 'success',
                    summary: 'Sucesso',
                    detail: `Comprovante incluído com sucesso.`,
                    life: 3000
                })

                this.$emit('save', {data: response.data, route: 'comprovante'});
            } catch (error) {
                if (error.response?.data?.erros) {
                    this.errors = error.response.data.erros
                } else if (error.response?.data?.msg) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: error.response.data.msg,
                        life: 10000
                    })
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Erro ao realizar upload',
                        life: 5000
                    })
                }
            } finally {
                this.isLoadingComprovante = false
            }
        },

        dateFormat(value) {
            if (!value) return;
            return Moment(value).format("DD/MM/YYYY HH:mm");
        },
        visualizar(data) {
            Arquivo.view(data.id)
                .then(response => {
                    File.openWindow(response);
                });
        },
        download(data) {
            Arquivo.view(data.id)
                .then(response => {
                    File.download(response);
                });
        },
        remove(arquivoID, route = 'boleto') {
            this.$confirm.require({
                message: 'Deseja realmente remover o item?',
                header: 'Remover',
                acceptLabel: 'Remover',
                icon: 'pi pi-trash',
                acceptClass: 'bg-red-500 text-white border-red-500',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Arquivo.delete(arquivoID)
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi removido com sucesso.', life: 3000 });
                            this.$emit('remove', route);
                        })
                        .catch(error => {
                            if (error.response) {
                                let err = error.response.data;
                                if (err.erros) {
                                    for (let i in err.erros) {
                                        this.errors[i] = err.erros[i][0];
                                    }
                                    return;
                                }
                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
        // uploadUrl(route) {
        //     switch (route) {
        //         case 'comprovante':
        //             return Arquivo.contaComprovante(this.data.id);
        //         default:
        //             return Arquivo.contaBoleto(this.data.id);
        //     }
        // },
        // beforeUpload(request) {
        //     let token = Token.get();
        //     request.xhr.setRequestHeader('Authorization', `Bearer ${token}`);

        //     request.formData.append('continua', this.continua);
        //     // pode incluir dados no upload
        //     return request;
        // },
        // onUploadError(event) {
        //     let error = JSON.parse(event.xhr.response);
        //     if (error.msg === 'Código de barras já foi cadastrado') {
        //         this.$confirm.require({
        //             message: 'Código de barras já existe. Deseja continuar mesmo assim?',
        //             header: 'Confirmação',
        //             icon: 'pi pi-exclamation-triangle',
        //             accept: () => {
        //                 this.continua = 1;
        //                 this.$refs.upload1.upload();
        //             },
        //             reject: () => {
        //                 this.$toast.add({
        //                     severity: 'info',
        //                     summary: 'Cancelado',
        //                     detail: 'Upload cancelado',
        //                     life: 3000
        //                 });
        //             }
        //         });

        //         event.xhr.readyState = event.xhr.OPENED;
        //     }
        //     else{
        //         this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.msg, life: 5000 });
        //     }
        // },
        // onUploaded(event, route = 'boleto') {
        //     this.continua = 0;

        //     this.$refs.upload1.clear();
        //     this.$refs.upload1.uploadedFileCount = 0;

        //     this.$refs.upload2.clear();
        //     this.$refs.upload2.uploadedFileCount = 0;

        //     let data = JSON.parse(event.xhr.response);
        //     this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O arquivo foi enviado com sucesso.', life: 3000 });
        //     this.$emit('save', {data: data, route: route});
        // },

        copiarCodigo(codigo){

            if (!codigo) return;

            try {
                navigator.clipboard.writeText(codigo);
                this.$toast.add({
                    severity: "success",
                    summary: "Copiado!",
                    detail: "Código de Barras copiado para a área de transferência",
                    life: 5000,
                    });
            } catch (error) {
                this.$toast.add({
                    severity: "error",
                    summary: "Erro",
                    detail: "Não foi possível copiar o código",
                    life: 5000,
                    });
            }
        },

    }
}
</script>
